import useSWR from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';
import type ILabelEnumPair from '../../components/global/GlobalInterfaces';

const GetStations = () :
{ stations: ILabelEnumPair[] | undefined,
  isLoading: boolean,
  isError: boolean, } => {
  const fetcher = (url: string) => axios.get<ILabelEnumPair[]>(url)
    .then((response) => response.data);

  const { data, error } = useSWR<ILabelEnumPair[], AxiosError>('/employeeInfo/getJobFunctions',
    (url) => fetcher(url));

  return {
    stations: data,
    isLoading: !error && !data,
    isError: Boolean(error),
  };
};

export default GetStations;
